module.exports = __webpack_public_path__ + "static/media/logo.9478f7e8.svg";